module.exports = __webpack_public_path__ + "img/workFlowXls.89739c48.png";